import { FC, JSX } from "react";
import { Flex, Text } from "@radix-ui/themes";
import { Profile } from "@/models/Profile.model";
import { StarIcon } from "@radix-ui/react-icons";

const ProfileRating: FC<Partial<Profile>> = (): JSX.Element => {
  return (
    <Flex direction="row" gap="3" align="center">
      <Flex gap="0" align="center">
        {Array.from({ length: 5 }, (_, i) => (
          <StarIcon color="gray" key={i} />
        ))}
      </Flex>
      <Text size="1" color="gray">
        Not yet rated
      </Text>
    </Flex>
  );
};

export default ProfileRating;
